import {retrieveRequestFactory, putRequestFactory, UPDATE_ITEMS} from 'store/generic/actions';
import {ADD_ITEM, DELETE_ITEM, EDIT_ITEM, ADD_ITEMS} from "../generic/actions";


export const COLLECTION_NAME = 'card';

const UPDATE_CARDS = `${UPDATE_ITEMS}_${COLLECTION_NAME.toUpperCase()}`;
const ADD_CARD = `${ADD_ITEM}_${COLLECTION_NAME.toUpperCase()}`;
const DELETE_CARD = `${DELETE_ITEM}_${COLLECTION_NAME.toUpperCase()}`;
const EDIT_CARD = `${EDIT_ITEM}_${COLLECTION_NAME.toUpperCase()}`;
const ADD_CARDS = `${ADD_ITEMS}_${COLLECTION_NAME.toUpperCase()}`;




const updateCards = (payload) => ({
    type: UPDATE_CARDS,
    version: payload.version,
    changed_items: payload.cards
});

export const retrieveCards = () => {
    return retrieveRequestFactory('cards', COLLECTION_NAME, true, updateCards)()
};

export const addCard = (card) => ({
    type: ADD_CARD,
    item: card,
});

export const addCards = (cards) => ({
    type: ADD_CARDS,
    items: cards,
})

export const deleteCard = (card) => ({
    type: DELETE_CARD,
    item: card
});

export const editCard = (card, changes) => ({
    type: EDIT_CARD,
    item: card,
    changes: changes
});


export const putCards = () => (
    (dispatch, getState) => {
        const state = getState();
        return dispatch(putRequestFactory('cards', {cards: state.card.put}, COLLECTION_NAME)());
    }
);



// WEBPACK FOOTER //
// ./src/store/cards/actions.js